<div>
  <div class="strong-text">
    {{ uiService.productName }} is not authorized to access {{ issue.clusterName }} on your behalf.
  </div>
  <div class="padding-top">
    One of the following command sets will give {{ uiService.productName }} permission to query resources from
    {{ issue.clusterName }}:
  </div>
  <div class="padding-top">If {{ issue.clusterName }} is using EKS API auth:</div>
  <div class="command-block">
    <button class="copy-btn" [copy-clipboard]="accessEntryCommandToRun" (copied)="copyFeedback.onCopied('accessEntry')">
      @if (copyFeedback.copiedStates['accessEntry']) {
        <svg lucideCheck class="copy-check"></svg>
      } @else {
        <svg lucideCopy></svg>
      }
      {{ copyFeedback.copiedStates['accessEntry'] ? 'Copied' : 'Copy' }}
    </button>
    <pre><code>{{ accessEntryCommandToRun }}</code></pre>
  </div>
  <div class="padding-top">Or for the older, deprecated, ConfigMap method:</div>
  <div class="command-block">
    <button class="copy-btn" [copy-clipboard]="commandToRun" (copied)="copyFeedback.onCopied('configMap')">
      @if (copyFeedback.copiedStates['configMap']) {
        <svg lucideCheck class="copy-check"></svg>
      } @else {
        <svg lucideCopy></svg>
      }
      {{ copyFeedback.copiedStates['configMap'] ? 'Copied' : 'Copy' }}
    </button>
    <pre><code>{{ commandToRun }}</code></pre>
  </div>
  <div class="padding-top">
    For more information, visit our
    <a target="_blank" href="http://docs.arpio.io/setting-up-eks">setting up EKS documentation</a>.
  </div>
  <div class="padding-top">
    Original error message: <span class="code small">{{ issue.originalMessage }}</span>
  </div>
</div>
